import React, { useContext } from 'react';
import { AuthContext } from './contexts/AuthContext';
import { NavLink, useNavigate } from 'react-router-dom';
import './NavBar.css';

const NavBar = () => {
    const { user, handleGoogleSignIn, loading, showNavLinks, setShowNavLinks, isAdmin, setFetchData } = useContext(AuthContext) ?? {};
    const navigate = useNavigate();

    const gotoHomePage = () => {
        if (isAdmin) {
            setShowNavLinks(false);
            setFetchData({});
            navigate('/adminHome');
        } else {
            navigate('/home');
        }
    }

    return (
        <nav className="navbar-container">
            <div className="navbar-contents">
                <h2 className="hbm-logo" onClick={gotoHomePage}>Heart Breath Mind</h2>
                {(user && !loading && showNavLinks) ? (
                    <ul className="nav-list">
                        <li><NavLink to="/home" className={({ isActive }) => (isActive ? 'active-page' : '')}>Dashboard</NavLink ></li>
                        <li><NavLink to="/yourData" className={({ isActive }) => (isActive ? 'active-page' : '')}>Your Data</NavLink ></li>
                        <li><NavLink to="/analysis" className={({ isActive }) => (isActive ? 'active-page' : '')}>Analysis</NavLink ></li>
                        <li><NavLink to="/sessions" className={({ isActive }) => (isActive ? 'active-page' : '')}>Sessions</NavLink ></li>
                        <li><NavLink to="/experiments" className={({ isActive }) => (isActive ? 'active-page' : '')}>Experiments</NavLink ></li>
                        <li><NavLink to="/behavioralTracking" className={({ isActive }) => (isActive ? 'active-page' : '')}>Behavioral Tracking</NavLink ></li>
                        <li><NavLink to="/profile" className={({ isActive }) => (isActive ? 'active-page' : '')}>Profile</NavLink ></li>
                    </ul>
                ) : (user && !loading && isAdmin) ? (
                    <ul className="nav-list">
                        <li><NavLink to="/adminHome" className={({ isActive }) => (isActive ? 'active-page' : '')}>Admin Home</NavLink ></li>
                        <li><NavLink to="/profile" className={({ isActive }) => (isActive ? 'active-page' : '')}>Profile</NavLink ></li>
                    </ul>
                ) : (
                    <a style={{ cursor: 'pointer' }} onClick={handleGoogleSignIn}>Sign in</a>
                )}
            </div>
        </nav>
    );
};

export default NavBar;